import React from "react";
import { Link } from "react-router-dom";
import demoLogo from "../images/CAMadhuri_Logo.svg"; // Import CA Madhuri logo
import "./Navbar.css"; // Import CSS

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar shadow">
      <div className="container">
        {/* Logo with Text */}
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img src={demoLogo} alt="Logo" className="demo-logo me-3" />
          <span className="animated-text">CA Madhuri</span>
        </Link>

        {/* Toggle Button for Mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About Us</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/services">Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact Us</Link>
            </li>

            {/* Important Links Dropdown */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="importantLinksDropdown"
                role="button"
                data-bs-toggle="dropdown"
              >
                Important Links
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="https://www.incometax.gov.in/iec/foportal/" target="_blank" rel="noopener noreferrer">
                    Income Tax
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://www.gst.gov.in/" target="_blank" rel="noopener noreferrer">
                    GST
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://www.esic.gov.in/" target="_blank" rel="noopener noreferrer">
                    ESIC
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://www.mca.gov.in/content/mca/global/en/home.html" target="_blank" rel="noopener noreferrer">
                    MCA
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://www.epfindia.gov.in/site_en/index.php" target="_blank" rel="noopener noreferrer">
                    Provident Fund
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://msme.gov.in/" target="_blank" rel="noopener noreferrer">
                   MSME
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
